import { Checkbox, FormControlLabel, List, ListItem } from '@mui/material';
import { UseFormSetValue } from 'react-hook-form';
import { UserForm } from '../details/UserDetails';

interface UserTaskGroupProps {
  taskGroupOptions: { title: string; value: string }[];
  userTaskGroups: any;
  setUserTaskGroups: any;
  setValue: UseFormSetValue<UserForm>;
}

export const UserTaskGroups = ({
  taskGroupOptions,
  userTaskGroups,
  setUserTaskGroups,
  setValue,
}: UserTaskGroupProps) => {
  return (
    <List sx={{ padding: '0 0 0 0.625rem' }}>
      {taskGroupOptions.map(
        (options: { title: string; value: string }, index: number) => {
          return (
            <ListItem key={`${options.title}_${index}`} disablePadding>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={!!userTaskGroups[options.value]}
                    onChange={(e) => {
                      const { value, checked } = e.target;
                      const currentTaskGroups = userTaskGroups;
                      const keyVal = value.split('.');
                      const key: string = keyVal?.[1];
                      const val: string = keyVal?.[0];

                      if (checked) {
                        currentTaskGroups[key] = val;
                        setUserTaskGroups({ ...currentTaskGroups });
                      } else {
                        delete currentTaskGroups[key];
                        setUserTaskGroups({ ...currentTaskGroups });
                      }

                      setValue('taskGroups', currentTaskGroups, {
                        shouldDirty: true,
                      });
                    }}
                    value={`${options.title}.${options.value}`}
                  />
                }
                label={options.title}
              />
            </ListItem>
          );
        }
      )}
    </List>
  );
};
